import React from 'react'
export default function Bolt({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="currentColor" stroke="none">
      <path d="M13.5 2 4.6 13.1a.6.6 0 0 0 .47.98h4.99L9.1 21.3a.6.6 0 0 0 1.07.47l8.9-11.1a.6.6 0 0 0-.47-.98h-4.99l.96-7.22A.6.6 0 0 0 13.5 2z" />
    </svg>
  )
}
